module.exports = __webpack_public_path__ + "img/kwai.29eb3fc7.svg";